var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout40Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    width: 40,
    fill: "#b01657",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.792 35q-1.125 0-1.959-.833Q5 33.333 5 32.208V7.792q0-1.125.833-1.959Q6.667 5 7.792 5H19.75v2.792H7.792v24.416H19.75V35Zm19.583-7.375-1.958-2 4.25-4.25h-14.25v-2.75h14.208l-4.25-4.25 1.958-2L35 20.042Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout40Icon);
export default __webpack_public_path__ + "static/media/logout_40.icon.233e9b071c1dd4bf25b9981bc8105705.svg";
export { ForwardRef as ReactComponent };